import Vue from 'vue'
import VueRouter from 'vue-router'
import baseService from './routes/baseService'
import pluginService from './routes/pluginService'
import { fromAuthCenter, fromAdmin, ifAuthenticated, ifNotAuthenticated } from '@/libs/acl/routeProtection'
import {
    SUMMARY,
    COST_ALLOCATION_TAGS,
    CLOUD_FRONT,
    DATA_TRANSFER,
    ALL_CONSOLIDATED,
    COST_PIVOT,
    DYNAMIC_SEARCH,
    INVOICE,
    OPEN_API
} from '@/service'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/auth/megazone',
            meta: {
                layout: 'full'
            },
            component: () => import('@/views/Shared/PopsRecevieAuth.vue')
        },
        {
            path: '/auth/megazone/oauth/authorize',
            props: route => ({ code: route.query.code }),
            meta: {
                layout: 'full'
            },
            component: () => import('@/views/Shared/PopsReceiveAuthCode.vue')
        },
        {
            path: '/signin/email/:email/token/:token',
            meta: {
                layout: 'full'
            },
            props: route => ({ email: route.params.email, token: route.params.token }),
            beforeEnter: fromAuthCenter
        },
        {
            path: '/signin/admin/:email/:adminIdx/:userIdx/:token',
            meta: {
                layout: 'full'
            },
            props: route => ({ email: route.params.email, adminIdx: route.params.adminIdx, userIdx: route.params.userIdx, token: route.params.token }),
            beforeEnter: fromAdmin
        },
        {
            path: '/signin',
            meta: {
                layout: 'full'
            },
            name: 'auth-login',
            component: () => import('@/views/Auth/Main.vue'),
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/forgot-password',
            name: 'auth-forgot-password',
            component: () => import('@/views/ForgotPassword.vue'),
            meta: {
                layout: 'full'
            }
        },
        {
            path: '/error-404',
            meta: {
                layout: 'full'
            },
            name: 'error-404',
            component: () => import('@/views/error/Error404.vue')
        },
        {
            path: '/info',
            name: 'infomation',
            component: () => import('@/views/Info.vue'),
            meta: {
                services: [
                    'infomation'
                ]
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/infomation',
            redirect: '/info'
        },
        {
            path: '/notices',
            name: 'notices',
            component: () => import('@/views/Notice/BoardList.vue'),
            beforeEnter: ifAuthenticated,
            meta: {
                services: [
                    SUMMARY,
                    COST_ALLOCATION_TAGS,
                    CLOUD_FRONT,
                    DATA_TRANSFER,
                    ALL_CONSOLIDATED,
                    COST_PIVOT,
                    DYNAMIC_SEARCH,
                    INVOICE,
                    OPEN_API
                ]
            }
        },
        {
            path: '/notices/:service/:timestamp',
            name: 'noticeView',
            props: route => ({ service: route.params.service, timestamp: route.params.timestamp }),
            component: () => import('@/views/Notice/BoardListView.vue'),
            beforeEnter: ifAuthenticated,
            meta: {
                services: [
                    SUMMARY,
                    COST_ALLOCATION_TAGS,
                    CLOUD_FRONT,
                    DATA_TRANSFER,
                    ALL_CONSOLIDATED,
                    COST_PIVOT,
                    DYNAMIC_SEARCH,
                    INVOICE,
                    OPEN_API
                ]
            }
        },
        {
            path: '/agreement',
            name: 'agreement',
            component: () => import('@/views/Agreement.vue'),
            meta: {
                services: [
                    'agreement'
                ]
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '*',
            redirect: 'error-404'
        },
        ...baseService,
        ...pluginService
    ]
})

export const createRouter = () => router
export default router
